<template>
  <div class="mobile-layout" id="mobile-layout-main">
    <!-- <header class="mobile-header">
      <span class="mobile-header-title">H5 端</span>
      <span class="mobile-header-desc">vw 适配 · 设计稿 375</span>
    </header> -->
    <main class="mobile-main">
      <transition
        name="mobile-page"
        mode="out-in"
        @after-leave="onPageAfterLeave"
      >
        <router-view :key="$route.path" />
      </transition>
    </main>
    <mobile-footer v-if="showFooter" />
    <mobile-nav v-if="showNav" />
    <mobile-sidebar
      v-if="showPcSidebar"
      @to-top="onSidebarToTop"
      @to-bottom="onSidebarToBottom"
    />
  </div>
</template>

<script>
import MobileFooter from "./components/MobileFooter.vue";
import MobileNav from "./components/MobileNav.vue";
import MobileSidebar from "./components/MobileSidebar.vue";

export default {
  name: "MobileLayout",
  data() {
    return {
      deferScrollResetAfterEnter: false,
    };
  },
  components: {
    MobileFooter,
    MobileNav,
    MobileSidebar,
  },
  watch: {
    $route(to, from) {
      const fromHome = from && from.path === "/";
      const toMobileChild = to.path !== "/";
      this.deferScrollResetAfterEnter = fromHome && toMobileChild;
    },
  },
  computed: {
    showNav() {
      return this.$route.meta.showNav !== false;
    },
    showFooter() {
      return this.$route.meta.showFooter !== false;
    },
    /** 与 PcHeader 同理：由路由 meta 控制，默认不展示 */
    showPcSidebar() {
      return this.$route.meta.showPcSidebar === true;
    },
  },
  methods: {
    onPageAfterLeave() {
      if (!this.deferScrollResetAfterEnter) return;
      this.deferScrollResetAfterEnter = false;
      window.scrollTo({ top: 0, behavior: "auto" });
    },
    onSidebarToTop() {
      const el = document.getElementById("mobile-layout-main");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    onSidebarToBottom() {
      const el = document.getElementById("mobile-layout-main");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    },
  },
};
</script>

<style scoped>
.mobile-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 1.5;
  color: #333;

  font-family: 'Noto Sans JP', 'Noto Sans', sans-serif;
}
.mobile-header {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 12px 16px;
  background: #e0e8f0;
  border-bottom: 1px solid #b8c8d8;
}
.mobile-header-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
}
.mobile-header-desc {
  font-size: 12px;
  color: #555;
}
.mobile-main {
  flex: 1;
  /* padding: 16px; */
}

/* H5 子路由切换：淡入淡出 */
.mobile-page-enter-active,
.mobile-page-leave-active {
  transition: opacity 0.5s ease;
}
.mobile-page-enter,
.mobile-page-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .mobile-page-enter-active,
  .mobile-page-leave-active {
    transition-duration: 0.2s;
  }
}
</style>
